import React from "react";
import { Route } from "react-router-dom";
import UniversalResourceTable from "../pages/UniversalResourceTable";
import OrderDetailsNew from "../pages/OrderDetailsNew";
import OrderReview from "../pages/OrderReview";
import BookingsNew from "../pages/BookingsNew";
import BookingDetailsNew from "../pages/BookingDetailsNew";
import InventoryNew from "../pages/InventoryNew";
import ShippingRouter from "../pages/ShippingRouter";
import CustomerDetailsNew from "../pages/CustomerDetailsNew";
import CRMSettings from "../pages/CRMSettings";
import CreateOrder from "../pages/CreateOrder";
import CreateBooking from "../pages/CreateBooking";

/**
 * Orders, Bookings, Customers, Inventory, Shipping routes.
 */
export const OrderRoutes = ({ PrivateRoute }) => (
  <>
    <Route path="/orders" element={<PrivateRoute><UniversalResourceTable resourceType="orders" /></PrivateRoute>} />
    <Route path="/orders/leads" element={<PrivateRoute><UniversalResourceTable resourceType="leads" /></PrivateRoute>} />
    <Route path="/orders/inventory" element={<PrivateRoute><InventoryNew /></PrivateRoute>} />
    <Route path="/orders/shipping" element={<PrivateRoute><ShippingRouter /></PrivateRoute>} />
    <Route path="/orders/:orderId/review" element={<OrderReview />} />
    <Route path="/orders/:id" element={<PrivateRoute><OrderDetailsNew /></PrivateRoute>} />
    <Route path="/orders/new" element={<PrivateRoute><CreateOrder /></PrivateRoute>} />
    {/* /vendor/orders aliases — bell notifications, customer-request links, and
        a few legacy emails point here. Keep them mapped to the same components
        so vendors don't hit 404s when they click into an order from a notif. */}
    <Route path="/vendor/orders" element={<PrivateRoute><UniversalResourceTable resourceType="orders" /></PrivateRoute>} />
    <Route path="/vendor/orders/:id" element={<PrivateRoute><OrderDetailsNew /></PrivateRoute>} />
    <Route path="/bookings" element={<PrivateRoute><BookingsNew /></PrivateRoute>} />
    <Route path="/bookings/:id" element={<PrivateRoute><BookingDetailsNew /></PrivateRoute>} />
    <Route path="/bookings/new" element={<PrivateRoute><CreateBooking /></PrivateRoute>} />
    <Route path="/customers" element={<PrivateRoute><UniversalResourceTable resourceType="customers" /></PrivateRoute>} />
    <Route path="/customers/:id" element={<PrivateRoute><CustomerDetailsNew /></PrivateRoute>} />
    <Route path="/settings/crm" element={<PrivateRoute><CRMSettings /></PrivateRoute>} />
  </>
);
